import { prop } from 'ramda';
import { createSelector } from 'reselect';
import { useBetsSelector } from '../../store';

export const selectBets = () =>
  createSelector(prop('bets'), (bets) => {
    const { data, ids } = bets;
    return ids?.map((id) => data[id]);
  });

export const useBets = () => useBetsSelector(selectBets, []);
